import { FC } from 'react';

import { RaaSpinner } from 'raa-react';

import { DrawerFooter } from 'components/drawerSections/DrawerSections';

import { RequestStatus } from 'models';

interface SearchFooterProps {
  domanRequestStatus: RequestStatus;
  searchRequestStatus: RequestStatus;
  clearForm: () => void;
}

const SearchFooter: FC<SearchFooterProps> = ({ domanRequestStatus, searchRequestStatus, clearForm }) => {
  return (
    <DrawerFooter>
      <button
        className="raa-button raa-button-cancel tw-flex-1 md:tw-flex-none"
        disabled={domanRequestStatus === 'pending'}
        onClick={() => clearForm()}
        aria-label="Återställ formulär"
      >
        Rensa
      </button>
      <button
        className="raa-button raa-button-confirm tw-flex-1 md:tw-w-32 md:tw-flex-none"
        type="submit"
        form="searchForm"
        disabled={domanRequestStatus === 'pending' || searchRequestStatus === 'pending'}
      >
        {domanRequestStatus === 'pending' || searchRequestStatus === 'pending' ? <RaaSpinner size="1rem" /> : 'Sök'}
      </button>
    </DrawerFooter>
  );
};

export default SearchFooter;
